if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

      // Set-up event listener to listen for change event in <variant-radios>
      const sectionId = this.getAttribute('data-section');
      const variantRadios = document.getElementById(`VariantRadios-${this.dataset.sectionId}`)
      if(variantRadios) {
        this.currentVariant = variantRadios.getCurrentVariant();
        variantRadios.addEventListener('variantChange', this.onVariantChange.bind(this))
      }

      // Pull in parent product data
      this.getProductData();
    }

    /**
     * Pulls variants data for this product from a script tag that must be nested inside of the web component.
     * @returns {Object} Shopifys product.variants object for this product
     * @see https://shopify.dev/api/liquid/objects/product#product-variants
     */
    getProductData() {
      const jsonProductData = this.querySelector('#json-product[type="application/json"]');
      if(!this.productData && jsonProductData !== null) {
        this.productData = JSON.parse(jsonProductData.textContent).product;
        this.currencyCode = JSON.parse(jsonProductData.textContent).currency;
        // Remove the <script> tag we used to load the JSON from the DOM
        jsonProductData.parentNode.removeChild(jsonProductData);
      }
      return Array.isArray(this.productData) ? this.productData : [];
    }

    onVariantChange(e) {
      // Save Current Variant Data
      this.currentVariant = e.detail;
      // Add to Cart Enabled
      if(e.detail.available === true) {
        this.submitButton.removeAttribute('aria-disabled');
        this.submitButton.disabled = false;
        this.submitButton.querySelector('#cart-text-content').textContent = window?.variantStrings?.addToCart || 'Add to Cart';
        this.submitButton.classList.remove('visually-hidden');

        // If user lands on PDP with placeholder data, then selects valid variant, remove alert & set quantity input value
        const alertElement = document.querySelector('.placeholder-data-alert');
        if (alertElement && !alertElement.hasAttribute('hidden')) {
          location.reload();
        }
      // Add to Cart Disabled
      } else {
        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.disabled = true;
        this.submitButton.querySelector('#cart-text-content').textContent = window?.variantStrings?.soldOut || 'Sold Out';
        if(this.hasKlaviyoBis === true && this.klaviyoBis() !== null) {
          this.submitButton.classList.add('visually-hidden');
        }
      }
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          /**
           * GA4 DataLayer Event: Add To Cart
           * @see https://developers.google.com/analytics/devguides/collection/ga4/reference/events?client_type=gtm#add_to_cart
           */
          try {
            const {id: item_id, title: item_name, tags, type: item_category} = this.productData;
            const {id: item_variant} = this.currentVariant;
            const item = {
              item_id,
              item_name,
              item_variant,
              item_category,
              quantity: 1,
              ...calculatePrice({
                product: this.currentVariant,
                product_tags: Array.isArray(tags) ? tags : []
              })
            };
            pushDataLayerEvent({
              event: 'add_to_cart',
              ecommerce: {
                currency: this.currencyCode,
                value: calculateValue([item]),
                items: [item]
              }
            });
          } catch (error) {
            console.log('GA4: add_to_cart', error);
          }

          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
